import React from "react";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { FileNameRCProps } from "../../../interfaces/props/FileNameRCProps";

import classes from "./FileNameRC.module.css";

// название файла в чате
export function FileNameRC(props: FileNameRCProps): JSX.Element {
  const { fileName, deleteFileButton } = props;
  if (!fileName) return <></>;

  return (
    <div className={classes.file}>
      {fileName?.typeFile === true ? (
        <CheckCircleOutlined
          className={`${classes.file__icon} ${classes.file__icon_status_success}`}
        />
      ) : (
        <CloseCircleOutlined
          className={`${classes.file__icon} ${classes.file__icon_status_error}`}
        />
      )}
      <div className={classes.file__name}>{fileName?.message}</div>
      <DeleteOutlined
        className={`${classes.file__button} ${classes.file__button_action_delete}`}
        onClick={() => deleteFileButton()}
      />
    </div>
  );
}
